import { ElementRef, Injectable } from '@angular/core';

@Injectable()
export class DomHandler {

  public static zindex = 1050;

  public index(element: HTMLElement): number {
    const children = element.parentNode.childNodes;
    let num = 0;
    for (let i = 0; i < children.length; i++) {
      if (children[i] === element) return num;
      if (children[i].nodeType === 1) num++;
    }
    return -1;
  }

  public absolutePosition(element: HTMLElement, target: HTMLElement | SVGGraphicsElement, stickTo: 'right-bottom' | 'right-top' | 'left-bottom'): void {
    const elementDimensions = element.offsetParent ? {
      width: element.offsetWidth,
      height: element.offsetHeight
    } : this.getHiddenElementDimensions(element);
    const elementOuterHeight = elementDimensions.height;
    const elementOuterWidth = elementDimensions.width;
    let targetOuterHeight = (target as HTMLElement).offsetHeight;
    const targetOuterWidth = (target as HTMLElement).offsetWidth;
    const targetOffset = target.getBoundingClientRect();
    const windowScrollTop = this.getWindowScrollTop();
    const windowScrollLeft = this.getWindowScrollLeft();
    const viewport = this.getViewport();
    let top, left, right;

    if (!targetOuterHeight) {
      targetOuterHeight = (target as SVGGraphicsElement).getBBox().height;
    }

    if (!stickTo || stickTo === 'right-top') {
      if (targetOffset.top + targetOuterHeight + elementOuterHeight > viewport.height) {
        top = targetOffset.top + windowScrollTop - elementOuterHeight;
        if (top < 0) {
          top = 0 + windowScrollTop;
        }
      } else {
        top = targetOffset.top + windowScrollTop;
      }

      if (targetOffset.left + targetOuterWidth + elementOuterWidth > viewport.width) {
        left = targetOffset.left + windowScrollLeft + targetOuterWidth - elementOuterWidth;
      } else {
        left = targetOuterWidth + targetOffset.left + windowScrollLeft + 1;
      }
    } else if (stickTo === 'right-bottom') {
      // top = targetOuterHeight + targetOffset.top + windowScrollTop + 1;

      if (targetOffset.top + targetOuterHeight + elementOuterHeight > viewport.height) {
        top = targetOffset.top + windowScrollTop - elementOuterHeight;
        if (top < 0) {
          top = 0 + windowScrollTop;
        }
      } else {
        top = targetOuterHeight + targetOffset.top + windowScrollTop + 1;
      }


      left = targetOuterWidth + targetOffset.left + windowScrollLeft + 1;

      if (left > viewport.width) {
        left = targetOffset.left + windowScrollLeft + targetOuterWidth - elementOuterWidth;
      }
    } else if (stickTo === 'left-bottom') {
      if (targetOffset.top + targetOuterHeight + elementOuterHeight > viewport.height) {
        top = targetOffset.top + windowScrollTop - elementOuterHeight;
        if (top < 0) {
          top = 0 + windowScrollTop;
        }
      } else {
        top = targetOuterHeight + targetOffset.top + windowScrollTop + 1;
      }

      if (targetOffset.left + targetOuterWidth + elementOuterWidth > viewport.width) {
        left = targetOffset.left + windowScrollLeft + targetOuterWidth - elementOuterWidth;
      } else {
        left = targetOffset.left + windowScrollLeft;
      }
    } else if (stickTo === 'left-top') {
      if (targetOffset.top + targetOuterHeight + elementOuterHeight > viewport.height) {
        top = targetOffset.top + windowScrollTop - elementOuterHeight;
        if (top < 0) {
          top = 0 + windowScrollTop;
        }
      } else {
        top = targetOffset.top + windowScrollTop;
      }
      right = windowScrollLeft + (viewport.width - targetOffset.right) + targetOuterWidth + 1;
    }
    console.log('targetOffset', targetOffset);
    console.log('TOP', top);
    console.log('LEFT', left);
    console.log('RIGHT', right);
    element.style.top = top + 'px';
    if (right) {
      element.style.right = right + 'px';
    } else {
      element.style.left = left + 'px';
    }
  }

  public getHiddenElementDimensions(element: HTMLElement): { width: number, height: number } {
    const dimensions: { width: number, height: number } = {
      width: element.offsetWidth,
      height: element.offsetHeight
    };
    element.style.visibility = 'hidden';
    element.style.display = 'block';
    element.style.display = 'none';
    element.style.visibility = 'visible';

    return dimensions;
  }

  public getWindowScrollTop(): number {
    const doc = document.documentElement;
    return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
  }

  public getWindowScrollLeft(): number {
    const doc = document.documentElement;
    return (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
  }

  /*public matches(element, selector: string): boolean {
    const p = Element.prototype;
    const f = p['matches'] || p.webkitMatchesSelector || p['mozMatchesSelector'] || p.msMatchesSelector || function (s) {
      return [].indexOf.call(document.querySelectorAll(s), this) !== -1;
    };
    return f.call(element, selector);
  }*/

  public width(el) {
    let width = el.offsetWidth;
    const style = getComputedStyle(el);

    width -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
    return width;
  }

  public getViewport(): { width: number, height: number } {
    const win = window,
      d = document,
      e = d.documentElement,
      g = d.getElementsByTagName('body')[0],
      w = win.innerWidth || e.clientWidth || g.clientWidth,
      h = win.innerHeight || e.clientHeight || g.clientHeight;

    return {width: w, height: h};
  }

  appendChild(element: HTMLElement, target: any) {
    if (this.isElement(target)) {
      target.appendChild(element);
    } else if (target.el && target.el.nativeElement) {
      target.el.nativeElement.appendChild(element);
    } else {
      throw 'Cannot append ' + target + ' to ' + element;
    }
  }

  isElement(obj: HTMLElement) {
    return (typeof HTMLElement === 'object' ? obj instanceof HTMLElement :
        obj && typeof obj === 'object' && obj !== null && obj.nodeType === 1 && typeof obj.nodeName === 'string'
    );
  }
}
